<template>
  <v-layout>
    <div class="padding-container-lg">
      <v-patient-form :patient="patientData" :actionType="`edit`" @submit="validateBeforeSubmit"></v-patient-form>
    </div>
     <v-loader :isLoading="loading" />
  </v-layout>
</template>

<script>
import VPatientForm from '@/components/patient/PatientForm/index.vue';
import Transformer from '@/transformers/PatientTransformer';
import VLayout from '@/layouts/Default.vue';
import { mapGetters } from 'vuex';
import VLoader from '@/components/loader/index.vue';

export default {
  name: 'ModifyPatient',
  components: { VPatientForm, VLayout, VLoader },
  computed: {
    ...mapGetters({
      patient: 'patientList/getPatient',
      loading: 'patientList/getPatientEhrLoading',
    }),
    patientData() {
      return Transformer.fetch(this.patient);
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
     this.$store.dispatch('patientList/getPatient', this.$route.params.id);
    }
  },
  methods: {
    validateBeforeSubmit(data) {
      this.$store.dispatch('patient/updatePatientData', data );
    }
  }
};
</script>
